<route>
{
  "name": "Perfil",
  "meta": {
    "hasColoredBackground": true
  }
}
</route>
<template>
  <div>
    <loading :active.sync="loading" color="#5e72e4"></loading>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-info opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row" style="flex-basis: 100%;" v-if="perfil.precisaConfirmarDados">
          <div class="col-lg-8 col-md-7 col-12">
            <h1 class="display-4 text-white pt-4">Olá {{ perfil.nome }}!</h1>
            <p
              class="text-white mt-0 mb-5"
            >Para nos comunicarmos com maior eficiência e assim podermos fazer uma administração transparente e de qualidade, solicitamos, por gentileza, que confirme os dados do seu cadastro e salve as informações.</p>
          </div>
        </div>
      </div>
      <base-button class="my-md-4 mb-3 my-xl-0" type="secondary" :disabled="!alterado" @click="() => $router.push('/solicitar-troca-senha')">Trocar senha</base-button>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">
          <div class="card card-profile shadow">
            <div class="row justify-content-center">
              <div class="col-lg-3 order-lg-2">
                <div class="card-profile-image">
                  <img :src="foto.url" class="rounded-circle" />
                </div>
              </div>
            </div>
            <div
              class="d-flex card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4 justify-content-center"
              style="min-height: 200px; align-items: flex-end;"
            >
              <div>
                <avatar-cropper
                  :labels="{ submit: 'Confirmar', cancel: 'Cancelar'}"
                  trigger="#alterarFoto"
                  @uploading="uploading"
                  @uploaded="handleUploaded"
                  :upload-url="`${apiUrl}/api/v2/files`"
                />
                <base-button
                  id="alterarFoto"
                  size="sm"
                  type="primary"
                  icon="fa fa-camera"
                  class="float-right mb-4 mb-md-0"
                >Alterar Foto</base-button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-8 order-xl-1">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-6">
                  <h3 class="mb-0">Meus Dados</h3>
                </div>
              </div>
            </div>
            <template>
              <base-alert type="success" class="ml-4" v-if="mostrarConfirmacao">
                <i class="fa fa-check"></i>
                Seus dados foram atualizados
              </base-alert>
              <form @submit.prevent>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                        alternative
                        label="Nome"
                        placeholder="Nome"
                        input-classes="form-control-alternative"
                        v-model="perfilAlterado.nome"
                      />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        alternative
                        label="Email"
                        placeholder="seuemail@provedor.com"
                        input-classes="form-control-alternative"
                        v-model="perfilAlterado.email"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                        alternative
                        label="Celular"
                        placeholder="(99) 99999-9999"
                        type="tel"
                        v-mask="'(##) #####-####'"
                        input-classes="form-control-alternative"
                        v-model="perfilAlterado.celular"
                      />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        alternative
                        label="Telefone"
                        placeholder="(99) 99999-9999"
                        type="tel"
                        v-mask="['(##) ####-####', '(##) #####-####']"
                        input-classes="form-control-alternative"
                        v-model="perfilAlterado.telefone"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                        alternative
                        label="CPF/CNPJ"
                        placeholder="999.999.999-99"
                        type="tel"
                        v-mask="['###.###.###-##', '##.###.###/####-##']"
                        input-classes="form-control-alternative"
                        v-model="perfilAlterado.cpfCnpj"
                      />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        alternative
                        label="RG"
                        placeholder="RG"
                        input-classes="form-control-alternative"
                        v-model="perfilAlterado.rg"
                      />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                      alternative
                      label="Data de Nascimento"
                      >
                        <v-date-picker
                          ref="dataReserva"
                          :input-props="{ class: 'form-control form-control-alternative' }"
                          :popover="{ visibility: 'focus' }"
                          locale="pt-PT"
                          v-model="perfilAlterado.dataNascimento"
                        ></v-date-picker>
                      </base-input>
                    </div>
                  </div>
                </div>
                <div class="text-right">
                  <base-button type="success" :disabled="!alterado" @click="salvarPerfil()">Salvar</base-button>
                </div>
              </form>
            </template>
          </card>
        </div>
      </div>
      <div class="row mt-2" v-if="!isAcessoInquilino">
        <div class="col-xl-12">
          <card shadow type="secondary" bodyClasses="py-2">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center justify-content-between px-2">
                <div>
                  <h3 class="mb-0">Endereço</h3>
                </div>
              </div>
            </div>
            <template>
              <form @submit.prevent>
                <endereco v-model="perfilAlterado.endereco"></endereco>
                <div class="text-right">
                  <base-button type="success" :disabled="!alterado" @click="salvarPerfil()">Salvar</base-button>
                </div>
              </form>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import { diff } from "deep-diff";
import AvatarCropper from "vue-avatar-cropper";
import Endereco from "../components/Endereco";

const apiUrl = process.env.VUE_APP_API_URL;

export default {
  components: { AvatarCropper, Endereco },
  data() {
    return {
      perfilAlterado: {},
      foto: { url: "", alterado: false },
      loading: true,
      apiUrl,
      mostrarConfirmacao: false,
    };
  },
  watch: {
    perfil(novo) {
      this.perfilAlterado = { ...novo };
      this.perfilAlterado.endereco = this.perfilAlterado.endereco || {};
      this.perfilAlterado.dataNascimento = new Date(this.perfilAlterado.dataNascimento);
      this.foto.alterado = false;
      this.foto.url =
        novo.imagem ||
        "https://afcm.ca/wp-content/uploads/2018/06/no-photo.png";
    },
    alterado(novo) {
      this.mostrarConfirmacao = this.mostrarConfirmacao && !novo;
    }
  },
  computed: {
    ...mapState("usuario", ["perfil"]),
    ...mapGetters("auth", ["needUpdateProfile", "isAcessoInquilino"]),
    alterado() {
      return (
        this.perfil.precisaConfirmarDados ||
        Boolean(diff(this.perfilAlterado, this.perfil))
      );
    },
  },
  created() {
    this.carregarPerfilAtualizado();
  },
  methods: {
    ...mapActions("usuario", ["carregarPerfil"]),
    ...mapMutations("usuario", ["setPerfilValue"]),
    ...mapMutations("auth", ["setPerfil"]),
    carregarPerfilAtualizado(redirect) {
      this.loading = true;
      this.carregarPerfil().then(() => {
        if (!this.perfil.precisaConfirmarDados && this.needUpdateProfile) {
          this.setPerfil(this.perfil);
        }
        if (redirect) {
          this.$router.push("/");
          return;
        }
        this.loading = false;
      });
    },
    uploading() {
      this.loading = true;
    },
    handleUploaded(resp) {
      const perfil = this.perfil;
      const imagem = { imagem: resp };
      this.salvarPerfil({ ...perfil, ...imagem });
    },
    salvarPerfil(perfil) {
      const ehConfirmacaoDeDados = this.perfil.precisaConfirmarDados;
      this.loading = true;
      var perfilAtualizado = perfil || this.perfilAlterado;
      this.$http.put("/api/v2/usuario/perfil", perfilAtualizado).then(() => {
        this.mostrarConfirmacao = true;
        this.carregarPerfilAtualizado(ehConfirmacaoDeDados);
      });
    },
  },
};
</script>
